import { useSelector } from "react-redux";
import { RootState } from "../../../App/store";
import "./Overlay.scss";

export const Overlay = () => {
  const overlaySelector = useSelector((state: RootState) => state.overlay);

  return (
    <>
      {overlaySelector.status ? (
        <div className="Overlay">{overlaySelector.renderContent}</div>
      ) : (
        ""
      )}
    </>
  );
};
export default Overlay;
